import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Grid, Block, Spacer } from "../../atoms/layout-primitives"
import Button from "../../atoms/button"
import ContentBlock from "../../molecules/content-block"
import withAnimation from "../../util/withAnimation"
import { FadeIn, FadeInBottom } from "../../styles/animations.styles"
import BreakpointImage from "../../atoms/breakpoint-image"

const Span = styled.span`
  display: inline-block;
`

const AnimatedSpan = withAnimation(Span)

const Line = styled.div`
  display: block;
  width: 1440;
  height: 100;
  color: black;
`

export default function MappingSolutionsSection() {
  const query = useStaticQuery(graphql`
    query {
      workflowDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Imdf/1_Desktop/IMDF_workflow_infographic.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      workflowMobile: file(
        relativePath: {
          eq: "1_SOLUTIONS/Imdf/3_Mobile/IMDF_worfklow_infographic_mobile.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Spacer height={{ sm: "64px", lg: "96px" }} />
      <Grid>
        <Block.Animated
          animation={FadeInBottom}
          col={{ sm: "1 / -1", md: "3 / -3", lg: "3 / -3 " }}
          align={{ lg: "center" }}
        >
          <BreakpointImage
            imageVariants={{
              sm: query.workflowMobile.childImageSharp.fluid,
              md: query.workflowDesktop.childImageSharp.fluid,
              lg: query.workflowDesktop.childImageSharp.fluid,
            }}
          />
        </Block.Animated>
      </Grid>
      <Spacer height={{ sm: "64px", lg: "96px" }} />
      <Grid>
        <Block
          row={{ sm: "1" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "-7 / -2" }}
          align={{ lg: "center" }}
        >
          <ContentBlock.H3
            title={
              <AnimatedSpan animation={FadeIn}>Convert to IMDF</AnimatedSpan>
            }
            description={
              <AnimatedSpan animation={FadeInBottom}>
                Mappedin’s Platform transforms 2D floor plans and blueprints
                into digital assets to be used in any venue type. Along with
                powerful front-end experiences, Mappedin has the ability to
                convert your indoor mapping data to IMDF. This export allows
                maps to be maintained over time and provides you with the
                flexibility to build any indoor mapping experience.
              </AnimatedSpan>
            }
            variants={[null, { textAlign: "center" }, { textAlign: "center",  paddingLeft: '32px' }]}
          />
        </Block>
        <Spacer height={{ sm: "32px", md: "48px", lg: "0px" }} />
        <Block
          row={{ lg: "1" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "2 / 7" }}
          align={{ lg: "center" }}
        >
          <ContentBlock.H3
            title={
              <AnimatedSpan animation={FadeIn}>Maintain IMDF</AnimatedSpan>
            }
            description={
              <AnimatedSpan animation={FadeInBottom}>
                As locations within your venue change and grow, Mappedin's
                Editor acts as a centralized management tool to edit your indoor
                maps and maintain accurate data. Edit location information,
                manage map geometry, and more to ensure that your IMDF stays
                up-to-date. Changes to your map are exported to Apple so that
                visitors can rely on accurate data.
              </AnimatedSpan>
            }
            variants={[null, { textAlign: "center" }, { textAlign: "center", paddingRight: "32px" }]}
          />
        </Block>
      </Grid>

      <Spacer  height={{ sm: "64px", md: "32px", lg: "48px" }} />

      <Button.ScrollLink
        to="contact-form"
        variants={{ sm: { margin: "0 auto" } }}
        smooth
        duration={1000}
      >
        Contact Us
      </Button.ScrollLink>
      <Spacer height={{ sm: "64px", lg: "96px" }}  />

      <Line />
    </>
  )
}
